import constants from '../../../../../../../../../appConstants';
import {
  DateTimeFilter,
  MultiSelectFilter,
} from '@dataGrid/components/columnFilters';
import { formatDateTimeWithoutUTCConversion } from '@dataGrid/gridUtilities';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getDriverName = (params) => {
    return params.data.driverId ? `${params.data.driver} (#${params.data.driverNumber})` : '';
  };

  static getDefaultConfiguration() {
    return {
      title: constants.gridNames.DispatchPickupHistoryGrid,
      keyColumn: 'eventId',
      rowSelection: 'multiple',
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true
      },
      columns: [
        {
          headerName: 'Date Time',
          headerTooltip: 'Destination Terminal',
          minWidth: constants.columnWidth.W_130,
          field: 'eventDateTime',
          cellClass: 'gridCell-leftAlign',
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME
          },
          valueFormatter: formatDateTimeWithoutUTCConversion,
          lockPosition: true
        },
        {
          headerName: 'Event',
          headerTooltip: 'Event',
          field: 'pickupEvent',
          minWidth: constants.columnWidth.W_180,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          lockPosition: true,
          tooltipField: 'pickupEvent',
        },
        {
          headerName: 'Action By',
          field: 'actionBy',
          minWidth: constants.columnWidth.W_180,
          headerTooltip: 'Pieces',
          tooltipField: 'actionBy',
          filter: MultiSelectFilter,
          cellClass: 'gridCell-leftAlign'
        },
        {
          headerName: 'Source',
          field: 'source',
          minWidth: constants.columnWidth.W_120,
          headerTooltip: 'Total weight',
          cellClass: 'gridCell-centerAlign',
          filter: MultiSelectFilter
        },

        {
          headerName: 'Driver',
          field: 'driverName',
          minWidth: constants.columnWidth.W_240,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueGetter: GridConfig.getDriverName,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: 'Trailer #',
          headerTooltip: 'Trailer Number',
          field: 'trailerNumber',
          minWidth: constants.columnWidth.W_120,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Tractor #',
          field: 'tractorNumber',
          minWidth: constants.columnWidth.W_120,
          headerTooltip: 'Tractor Number',
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Manifest #',
          field: 'manifestNumber',
          headerTooltip: 'Manifest Number',
          minWidth: constants.columnWidth.W_120,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Merged to Pickup #',
          field: 'mergedTo',
          minWidth: constants.columnWidth.W_170,
          headerTooltip: 'Service Level',
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Terminal',
          minWidth: constants.columnWidth.W_110,
          field: 'terminal',
          headerTooltip: 'Trailer',
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        }
      ]
    };
  }
}
